// Mock data for Hinton Enterprises - One Page Website

export const brands = [
  {
    id: 1,
    name: "Hinton.",
    slug: "hinton-online",
    tagline: "Multi-Platform Digital Publication",
    description: "Hinton is a multi-platform digital media platform delivering fresh perspectives across news, business, fashion, health, and lifestyle. Featuring original series like Hinton Visits and In Conversation With.",
    image: "/logos/hinton-dot.png",
    services: [
      "News",
      "Business & Finance",
      "Fashion / Health / Lifestyle",
      "Hinton Visits",
      "In Conversation With"
    ],
    link: "#",
    email: "contact@hintononline.com",
    socials: {
      instagram: "https://www.instagram.com/hintononline/",
      website: "https://HintonOnline.com"
    }
  },
  {
    id: 2,
    name: "Hinton Media",
    slug: "hinton-media",
    tagline: "Websites, Social Media, SEO & App Building",
    description: "We build digital experiences that drive results. From websites and apps to social media strategy and SEO, Hinton Media helps brands establish and grow their online presence.",
    image: "/logos/hinton-media.png",
    services: [
      "Website Design & Development",
      "Social Media Management",
      "SEO & Digital Marketing",
      "App Building"
    ],
    link: "#",
    email: "Info@Hinton-Media.com",
    socials: {
      website: "https://hinton-media.com"
    }
  },
  {
    id: 3,
    name: "Hinton Agency",
    slug: "hinton-agency",
    tagline: "The Retail Bridge Between Brands and Opportunity",
    description: "We work with brands worldwide, helping them access opportunities within the UK retail market through established retail and marketplace channels.",
    image: "/logos/hinton-agency.png",
    services: [
      "Brand Representation",
      "UK Market Entry",
      "Retail Partnerships",
      "Brand Building"
    ],
    link: "#",
    email: "Info@Hinton-agency.com",
    socials: {
      website: "https://Hinton-Agency.com"
    }
  }
];

export const companyInfo = {
  name: "Hinton Enterprises Ltd",
  tagline: "",
  description: "A creative ecosystem operating across media, retail, and brand representation. From digital publishing to marketplace platforms, we're building the future of brand experiences.",
  address: "124 City Road, London, England, EC1V 2NX",
  email: "Info@Hinton-Media.com",
  phone: ""
};

export const stats = [
  { label: "Clients Served", value: "500+" },
  { label: "Founded", value: "2017" },
  { label: "Market Reach", value: "Global" }
];
